<template>
  <CModal
    :show.sync="isOpen"
    :close-on-backdrop="true"
    @close="close"
  >
    <template #header>
      <div class="d-flex align-items-center">
        <div class="failed-modal-icon mr-3">
          <CIcon name="cipAlertTriangle" size="xl"/>
        </div>
        <h5 class="modal-title mb-0">
          <translate translate-context="globalUploader.failedModal">Incomplete upload</translate>
        </h5>
      </div>
    </template>

    <div class="failed-uploads-content">
      <p class="text-muted mb-3">
        <translate translate-context="globalUploader.failedModal">
          One or more files in the group were not uploaded correctly. Re-upload the entire folder: the system will automatically identify the missing file and upload only that one.
        </translate>
      </p>

      <div class="failed-files-list">
        <div v-for="file in files" :key="file.md5" class="failed-file-item d-flex align-items-center py-2">
          <CIcon name="cipXCircle" class="text-danger mr-2" size="sm"/>
          <span class="file-name text-truncate text-danger">{{ file.name }}</span>
        </div>
      </div>
    </div>

    <template #footer>
      <CButton color="secondary" variant="outline" @click="close">
        <translate translate-context="globalUploader.failedModal">Close</translate>
      </CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: 'FailedUploadsModal',
  data() {
    return {
      isOpen: false,
      files: []
    }
  },
  methods: {
    open(files) {
      this.files = files || []
      this.isOpen = true
    },
    close() {
      this.isOpen = false
      this.files = []
    }
  }
}
</script>

<style scoped>
.failed-modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fff3e0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f9a825;
}

.failed-files-list {
  max-height: 300px;
  overflow-y: auto;
}

.file-name {
  flex: 1;
  min-width: 0;
}
</style>
